import React, { useContext } from "react";
import DynamicHtml from "../CommonComponent/DynamicHtml";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";
import { CommonService, PendoService } from "@services";

const PrescriberNoteTableCell = ({ field, prescriberNoteResponseLowerCase, cssClassName, resultRow }) => {
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { benefitType, productId, productName, indicationName } = useContext(SearchContext);
  const benefitTypeId = benefitType == "Pharmacy" ? 2 : 1;

  const openDocumentLinks = (cellData) => {
    if (cellData && cellData.length > 0) {
      let links = cellData.split("<br>");
      for (let i = 0; i < links.length; i++) {
        let link = links[i];
        if (link) {
          let url = CommonService.getHrefFromHtml(link);
          if (url) {
            //pendo track event
            PendoService.getInstance().trackEvent("Policy Document" + (i + 1) + " Url", "openDocumentLinks", url, productId, productName, indicationName);
            window.open(url, "_blank", "noopener,noreferrer");
          }
        }
      }
    }
  };

  const getTableCellHTML = (field) => {
    let cellData = prescriberNoteResponseLowerCase && CommonService.objectHasProperty(prescriberNoteResponseLowerCase, field.dataField.toLowerCase())
      ? prescriberNoteResponseLowerCase[field.dataField.toLowerCase()]
      : resultRow[field.dataField];

    if (field.dataField?.toLowerCase()?.includes("policy_links")) {
      const noteIcons = appliedConfiguration?.coverageFinderGridColumnIcons?.filter(
        (item) =>
          item.coverageFinderColumnId === field.id &&
          item.benefitTypeId === benefitTypeId &&
          item.columnDataField.includes("Policy Links") &&
          item.gridType == "notes"
      );

      const noteAllDocTypesIconPath = appliedConfiguration?.coverageFinderGridColumnIcons?.find(
        (item) =>
          item.coverageFinderColumnId === field.id &&
          item.benefitTypeId === benefitTypeId &&
          item.columnDataField.includes("Policy Links") &&
          item.dataElement === "-" &&
          item.gridType == "notes"
      )?.iconPath;

      if (field.documentTypes) {
        const documentTypes = field.documentTypes.split(",");
        for (let i = 0; i < documentTypes.length; i++) {
          const documentType = documentTypes[i];
          const noteIconPath = noteIcons.find((noteIcon) => noteIcon.dataElement === documentType)?.iconPath;
          if (noteIconPath) {
            const docNameRegex = /-\d</gi;
            cellData = cellData.replaceAll(docNameRegex, "<");

            cellData = cellData.replaceAll(
              `>${documentType}<`,
              `><img src="${noteIconPath}" alt="${documentType}" width="24" height="24" /><`
            );
          }
        }
      } else if (noteAllDocTypesIconPath) {
        return (
          <>
            <button
              className="norstella-cf-note-button"
              part="cfNoteButton"
              onClick={() => openDocumentLinks(cellData)}
            >
              <img src={noteAllDocTypesIconPath} alt="Document Links" width="24" height="24" />
            </button>
          </>
        );
      }
    }

    return <DynamicHtml input={cellData} part="cfNoteCell" className={cssClassName} />;
  };

  return getTableCellHTML(field);
};

export default PrescriberNoteTableCell;
